import { MdPlaylistAddCheck } from 'react-icons/md';
import { Resources } from '../../resource';
import { MainPage } from './main-page';

export const name = Resources.worldCupWhitelist;

export const list = MainPage;

export const icon = MdPlaylistAddCheck;

export const options = { label: 'resource.worldCupWhitelist' };
